import { render, staticRenderFns } from "./signForDialog.vue?vue&type=template&id=2b573d30&scoped=true"
import script from "./signForDialog.vue?vue&type=script&lang=js"
export * from "./signForDialog.vue?vue&type=script&lang=js"
import style0 from "./signForDialog.vue?vue&type=style&index=0&id=2b573d30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b573d30",
  null
  
)

export default component.exports